import { ComboboxOption } from '../types.ts';

type WithDefaultSearchableComboboxOptionParams = {
    options: ComboboxOption[];
    existingOptions?: ComboboxOption[];
    defaultOption?: ComboboxOption;
};

export function withDefaultSearchableComboboxOption({
    options,
    defaultOption,
    existingOptions,
}: WithDefaultSearchableComboboxOptionParams): ComboboxOption[] {
    if (!defaultOption) {
        return options;
    }

    if (options.some(option => option.value === defaultOption.value)) {
        return options;
    }

    if (existingOptions?.some(option => option.value === defaultOption.value)) {
        return options;
    }

    return [{ value: defaultOption.value, label: defaultOption.label }, ...options];
}
